import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { getSpecificStep } from 'modules/steps/actions';
import Step from '../components';

function mapStateToProps(state) {
  return {
    actualContext: state.steps.context,
    specificStep: state.steps.specificStep,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getSpecificStep: bindActionCreators(getSpecificStep, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Step));



// WEBPACK FOOTER //
// ./src/routes/Step/container/index.js